// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"120":"ca13065a","856":"b13addf5","860":"bc070076"}[chunkId] + ".js";
};